export const loginPage = {
  pageTitle: 'Inicio de sesión',
  mainTitle: 'Comience su construcción con nosotros.',
  text: 'Para iniciar sesión en su cuenta personal, tiene que reservar una llamada para encargar un proyecto. Después de eso, recibirá una contraseña, que podrá cambiar.',
  btnText: 'Siguiente',
  popupIncorrectText: 'La contraseña o el nombre de usuario no son correctos',
};
